import React from "react";
import {
  GraduationCap, Wallet, DoorOpen, LogOut, MailCheck, MessageSquare,
  UtensilsCrossed, BookOpen, CheckCircle2, Medal, Download,
} from "lucide-react";

/* Maquettes stylisées de l'app parent, affichées dans le "téléphone" de la visite guidée /demo */

const Row = ({ children, className = "" }) => (
  <div className={`bg-white rounded-xl border border-slate-200 p-3 ${className}`}>{children}</div>
);

export const MockNotes = () => (
  <div className="space-y-2.5">
    <div className="text-xs font-bold text-slate-500 uppercase">Notes de Fatoumata — CM2</div>
    {[["Mathématiques", "17/20", "#166534"], ["Français", "15/20", "#1E3A8A"], ["Sciences", "18/20", "#166534"]].map(([m, n, c]) => (
      <Row key={m} className="flex items-center justify-between">
        <div className="flex items-center gap-2"><GraduationCap className="h-4 w-4 text-slate-400" /><span className="text-sm font-semibold text-slate-700">{m}</span></div>
        <span className="text-sm font-extrabold" style={{ color: c }}>{n}</span>
      </Row>
    ))}
    <Row className="bg-blue-50 border-blue-200 flex items-center justify-between">
      <span className="text-xs font-bold text-[#1E3A8A]">Moyenne générale</span>
      <span className="text-lg font-extrabold text-[#1E3A8A]">16,7 / 20 · 2e</span>
    </Row>
    <button className="w-full flex items-center justify-center gap-1.5 text-xs font-bold text-white bg-[#1E3A8A] rounded-lg py-2"><Download className="h-3 w-3" /> Bulletin PDF</button>
  </div>
);

export const MockPaiements = () => (
  <div className="space-y-2.5">
    <div className="text-xs font-bold text-slate-500 uppercase">Scolarité 2026-2027</div>
    <Row className="bg-green-50 border-green-200">
      <div className="flex justify-between text-xs font-bold text-[#166534]"><span>Payé : 6/9 tranches</span><span>67 %</span></div>
      <div className="h-2 bg-green-100 rounded-full mt-1.5"><div className="h-2 rounded-full bg-[#166534]" style={{ width: "67%" }} /></div>
    </Row>
    {[["Tranche 6 — Février", "payée"], ["Tranche 7 — Mars", "à venir"]].map(([t, s]) => (
      <Row key={t} className="flex items-center justify-between">
        <div className="flex items-center gap-2"><Wallet className="h-4 w-4 text-slate-400" /><span className="text-xs font-semibold text-slate-700">{t}</span></div>
        {s === "payée"
          ? <span className="text-[10px] font-bold text-green-700 bg-green-100 px-2 py-0.5 rounded-full flex items-center gap-1"><CheckCircle2 className="h-3 w-3" />Reçu PDF</span>
          : <span className="text-[10px] font-bold text-amber-700 bg-amber-100 px-2 py-0.5 rounded-full">Rappel J-5</span>}
      </Row>
    ))}
    <button className="w-full text-xs font-bold text-white bg-[#166534] rounded-lg py-2">Payer la tranche 7</button>
  </div>
);

export const MockPortail = () => (
  <div className="space-y-2.5">
    <div className="text-xs font-bold text-slate-500 uppercase">Alertes du portail</div>
    <Row className="bg-green-50 border-green-300">
      <div className="flex items-center gap-2 text-[#166534]"><DoorOpen className="h-4 w-4" /><span className="text-xs font-extrabold">ENTRÉE — 07 h 42</span></div>
      <p className="text-xs text-slate-600 mt-1">Fatoumata est bien arrivée à l&apos;école. Badge scanné au portail principal.</p>
    </Row>
    <Row className="bg-orange-50 border-orange-300">
      <div className="flex items-center gap-2 text-[#EA580C]"><LogOut className="h-4 w-4" /><span className="text-xs font-extrabold">SORTIE — 14 h 05</span></div>
      <p className="text-xs text-slate-600 mt-1">Fatoumata a quitté l&apos;école. Bonne fin de journée !</p>
    </Row>
    <Row className="flex items-center justify-between">
      <span className="text-xs font-semibold text-slate-600">Notifications SMS + Email</span>
      <span className="w-8 h-4.5 rounded-full bg-[#166534] relative"><span className="absolute right-0.5 top-0.5 w-3.5 h-3.5 bg-white rounded-full" /></span>
    </Row>
  </div>
);

export const MockRapport = () => (
  <div className="space-y-2.5">
    <div className="text-xs font-bold text-slate-500 uppercase">Rapport hebdomadaire — Sem. 24</div>
    <Row className="bg-purple-50 border-purple-200">
      <div className="flex items-center gap-2 text-purple-700"><MailCheck className="h-4 w-4" /><span className="text-xs font-extrabold">Reçu samedi 09 h 00</span></div>
    </Row>
    {[["Présence", "5 j / 5 — aucune absence", "#166534"], ["Notes de la semaine", "3 nouvelles notes · moy. 16,2", "#1E3A8A"], ["Devoirs à venir", "Maths (lundi) · Dictée (mardi)", "#EA580C"]].map(([t, v, c]) => (
      <Row key={t}>
        <div className="text-[10px] font-bold uppercase" style={{ color: c }}>{t}</div>
        <div className="text-xs text-slate-700 font-semibold mt-0.5">{v}</div>
      </Row>
    ))}
    <div className="text-[10px] text-slate-400 text-center">« Excellente semaine, élève sérieuse » — M. Camara</div>
  </div>
);

export const MockMessagerie = () => (
  <div className="space-y-2.5">
    <div className="text-xs font-bold text-slate-500 uppercase">Messagerie école</div>
    <div className="bg-slate-200 rounded-xl rounded-tl-sm p-2.5 text-xs text-slate-700 max-w-[85%]">
      Bonjour, Fatoumata peut-elle rattraper l&apos;évaluation de sciences ?
    </div>
    <div className="bg-[#1E3A8A] rounded-xl rounded-tr-sm p-2.5 text-xs text-white max-w-[85%] ml-auto">
      Bien sûr ! Rattrapage prévu jeudi à 10 h. Elle sera convoquée. — Administration
    </div>
    <Row className="flex items-center justify-between bg-cyan-50 border-cyan-200">
      <div className="flex items-center gap-2"><MessageSquare className="h-4 w-4 text-cyan-700" /><span className="text-xs font-semibold text-slate-700">Réclamation #128</span></div>
      <span className="text-[10px] font-bold text-green-700 bg-green-100 px-2 py-0.5 rounded-full">Résolue en 24 h</span>
    </Row>
  </div>
);

export const MockCantine = () => (
  <div className="space-y-2.5">
    <div className="text-xs font-bold text-slate-500 uppercase">Cantine & Bibliothèque</div>
    <Row className="flex items-center justify-between">
      <div className="flex items-center gap-2"><UtensilsCrossed className="h-4 w-4 text-amber-700" /><span className="text-xs font-semibold text-slate-700">Menu du jour : riz gras + jus</span></div>
      <span className="text-[10px] font-bold text-green-700 bg-green-100 px-2 py-0.5 rounded-full">Servie 12 h 15</span>
    </Row>
    <Row className="flex items-center justify-between">
      <div className="flex items-center gap-2"><BookOpen className="h-4 w-4 text-[#166534]" /><span className="text-xs font-semibold text-slate-700">« Le Petit Prince » emprunté</span></div>
      <span className="text-[10px] text-slate-400">Retour : 12 oct.</span>
    </Row>
    <Row className="bg-amber-50 border-amber-300 flex items-center gap-2">
      <Medal className="h-5 w-5 text-amber-600" />
      <div>
        <div className="text-xs font-extrabold text-amber-800">Badge « Lectrice d&apos;Argent » 🎉</div>
        <div className="text-[10px] text-slate-500">7 livres lus — au tableau d&apos;honneur de l&apos;école</div>
      </div>
    </Row>
  </div>
);
